import Carousel from 'react-elastic-carousel'
import HtmlParse from 'html-react-parser'
import { useLocalisationService } from 'providers/LocalisationProvider'
import 'css/carousel.css'

const TestimonialKeys = [
  'homepage_testimonial_1',
  'homepage_testimonial_2',
  'homepage_testimonial_3',
  'homepage_testimonial_4',
  'homepage_testimonial_5',
  'homepage_testimonial_6',
  'homepage_testimonial_7'
]

/**
 * Only the testimonials the active locale actually has. A locale is allowed to
 * leave these blank — they are attributed quotes and cannot be translated
 * without the speaker's approval — and an empty entry must not become a blank
 * carousel slide.
 *
 * Takes the service rather than calling `useLocalisationService()` itself, so
 * that callers can use it from inside a `_render*` helper without smuggling a
 * hook in there. See README, "Unusual patterns worth revisiting".
 */
export const getTestimonials = localisationService =>
  TestimonialKeys.map(key => localisationService.getString(key)).filter(
    text => text.trim() !== ''
  )

function Item({ children }) {
  return <div className='testimonial-card'>{children}</div>
}

export default function CarouselComponent() {
  const testimonials = getTestimonials(useLocalisationService())

  return (
    <Carousel itemsToShow={1}>
      {testimonials.map((testimonial, index) => (
        <Item key={index}>{HtmlParse(testimonial)}</Item>
      ))}
    </Carousel>
  )
}
